import React from 'react';

import { PrimaryButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';
import LanguageSelector from 'components/Globals/LanguageSelector';
import ProfileDropdown from 'components/Globals/ProfileDropdown';

import { TP } from 'constants/index';

import useAppContext from 'utils/hooks/useAppContext';
import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';
import { useDialogs } from 'utils/hooks/useDialogs';

import { useTranslation } from 'src/i18n';

import classes from './HeaderRightBlock.module.scss';

const LoggedInView = () => {
  const { isDesktop } = useDeviceTypeLayouts();

  if (!isDesktop) {
    return <ProfileDropdown />;
  }

  return (
    <nav>
      <ul className={classes.rightBlockLoggedIn}>
        <li className={classes.profileDropdown}>
          <ProfileDropdown />
        </li>
      </ul>
    </nav>
  );
};

const NonLoggedInView = ({ trackingData }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { setIsLoginDialog } = useDialogs();
  const { isDesktop } = useDeviceTypeLayouts();

  if (!isDesktop) {
    return (
      <PrimaryButton
        onClick={() => setIsLoginDialog({ isOpen: true })}
        shape="rectangle"
        size="medium"
        trackingData={{
          ...trackingData,
          subComponent: SUB_COMPONENTS.LOGIN_CTA,
        }}
      >
        {t(`${TP}.m_LOGIN`)}
      </PrimaryButton>
    );
  }

  return (
    <ul className={classes.rightBlock}>
      <li className={classes.navItem}>
        <LanguageSelector type="header" />
      </li>
      <li>
        <PrimaryButton
          onClick={() => setIsLoginDialog({ isOpen: true })}
          shape="rectangle"
          leftIcon={<SpriteIcon icon="account_circle" size={14} />}
          styles={{ icon: classes.accountIcon }}
          size="medium"
          trackingData={{
            ...trackingData,
            subComponent: SUB_COMPONENTS.LOGIN_CTA,
          }}
        >
          {t(`${TP}.m_LOGIN`)}
        </PrimaryButton>
      </li>
    </ul>
  );
};

const HeaderRightBlock = ({ trackingData }) => {
  const { isLoggedIn } = useAppContext();

  if (isLoggedIn) {
    return <LoggedInView />;
  }

  return <NonLoggedInView trackingData={trackingData} />;
};

export default HeaderRightBlock;
